module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On March 31, 1992, when the American battleship USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri")]), _vm._v(" was decommissioned for the second and final time, the age of the battleships irrevocably came to an end. At that time "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri")]), _vm._v(" was the last of its kind, representing a breed of warship that had dominated the world’s oceans in the early 20th century until its demise in World War II and its short-lived comeback in the final stages of the Cold War. Today, all the battleships are gone except a few, having survived as floating museums, thus having stood the test of time. Battleships were used as signs of national power and prestige, in a manner similar to the atomic weapons of today, and were thus considered a major factor in both diplomacy and military strategy for decades. This is their story.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4b6324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Introduction.vue
// module id = 69
// module chunks = 0